import { Link } from "react-router-dom";
import karen from "../images/karen/karen-the-game.png";
import rockPaperScissors from "../images/rps/rps-icon.jpeg";
import coinCollector from "../images/coin-collector.png";
import neonLanes from "../images/neon-lanes/neon-lanes-web.png";
import neonApexTrainingCircuit from "../images/neon-apex-training-circuit/trainginCircuit4.png";
import comingSoon from "../images/coming-soon.jpeg";

export default function Arcade() {
  return (
    <main className="arcade-page">
      <section className="text-area arcade-panel">
        <h1>ColdFlare Arcade</h1>

        <p className="arcade-intro">
          Play web games, experiments, and early ColdFlare projects.
        </p>

        <div className="coldflare-links arcade-games">
          
          <Link className="page-button game-card" to="/coincollector">
            <img
              className="page-button-image"
              src={coinCollector}
              alt="Coin Collector"
            />
            <p>Coin Collector</p>
            <span className="game-status">Play Now</span>
          </Link>

          <Link className="page-button game-card" to="/rockpaperscissors">
            <img
              className="page-button-image"
              src={rockPaperScissors}
              alt="Rock Paper Scissors"
            />
            <p>Rock Paper Scissors</p>
            <span className="game-status">Play Now</span>
          </Link>


          <a href="/games/karen/" className="page-button game-card">
            <img
              className="page-button-image"
              src={karen}
              alt="Karen game preview"
            />
            <p>Karen The Game</p>
            <span className="game-status">Play Now</span>
          </a>
          

          <a href="/games/neonLanes" className="page-button game-card">
            <img
              className="page-button-image"
              src={neonLanes}
              alt="Neon Lanes game preview"
            />
            <p>Neon Lanes</p>
            <span className="game-status">Play Now</span>
          </a>

          <a href="/games/NeonApexTrainingCircuit2" className="page-button game-card">
            <p className="warning">Keyboard required!</p>
            <img
              className="page-button-image"
              src={neonApexTrainingCircuit}
              alt="Neon Apex game preview"
            />
            <p>Neon Apex: Training Circuit</p>
            <span className="game-status">Play Now</span>
          </a>

          <Link className="page-button game-card coming-soon-card" to='/comingsoon'>
            <img
              className="page-button-image"
              src={comingSoon}
              alt="coming-soon"
            />
            <p>Coming Soon</p>
            
            <span className="game-status">Coming Soon</span>
          </Link>
        </div>
      </section>
    </main>
  );
}
